import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { connectGoogleCalendar } from '../../api/googleCalendar';

const GoogleCallbackPage = () => {
  const navigate = useNavigate();
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    if (!code) {
      enqueueSnackbar('Google авторизацію скасовано', { variant: 'warning' });
      navigate('/tutor/settings', { replace: true });
      return;
    }

    connectGoogleCalendar(code)
      .then(() => {
        enqueueSnackbar('Google Calendar підключено!', { variant: 'success' });
        navigate('/tutor/settings', { replace: true });
      })
      .catch(() => {
        enqueueSnackbar('Не вдалося підключити Google Calendar', { variant: 'error' });
        navigate('/tutor/settings', { replace: true });
      });
  }, [navigate]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '50vh', gap: 2 }}>
      <CircularProgress />
      <Typography variant="body1" color="text.secondary">
        Підключення Google Calendar...
      </Typography>
    </Box>
  );
};

export default GoogleCallbackPage;
